import BlogDescriptionController from "./BlogDescriptionController";

export default BlogDescriptionController;
